<template>
    <footer class="footer">
        <div class="footer-content">
            <div class="footer-top">
                <div class="footer-logo-section">
                    <span class="brand-text">TaskLink</span>
                    <!-- <img src="../assets/logo.png" alt="云链 TaskLink" class="footer-logo"> -->
                </div>
                <button class="footerjoinbtn">入驻人才库</button>
            </div>

            <div class="footer-links">
                <div class="footer-column">
                    <h3 class="footer-column-title">首页目录</h3>
                    <a href="#" class="footer-link">首页</a>
                    <a href="#" class="footer-link">招人才</a>
                    <a href="#" class="footer-link">找工作</a>
                </div>

                <div class="footer-column">
                    <h3 class="footer-column-title">WEB开发</h3>
                    <a href="#" class="footer-link">APP开发</a>
                    <a href="#" class="footer-link">软件开发</a>
                    <a href="#" class="footer-link">游戏开发</a>
                    <a href="#" class="footer-link">AI开发</a>
                </div>

                <div class="footer-column">
                    <h3 class="footer-column-title">视频剪辑</h3>
                    <a href="#" class="footer-link">UX设计</a>
                    <a href="#" class="footer-link">UI设计</a>
                    <a href="#" class="footer-link">品牌设计</a>
                    <a href="#" class="footer-link">Web设计</a>
                </div>

                <div class="footer-column">
                    <h3 class="footer-column-title">文案制作</h3>
                    <a href="#" class="footer-link">网站运维</a>
                    <a href="#" class="footer-link">翻译</a>
                    <a href="#" class="footer-link">品牌管理</a>
                    <a href="#" class="footer-link">营销策划</a>
                </div>

                <div class="footer-column">
                    <h3 class="footer-column-title">教育辅导</h3>
                    <a href="#" class="footer-link">初中教育辅导</a>
                    <a href="#" class="footer-link">高中教育辅导</a>
                    <a href="#" class="footer-link">高等教育辅导</a>
                    <a href="#" class="footer-link">音乐教育咨询</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default { name: 'AppFooter' }
</script>

<style lang="scss" scoped>
.brand-text {
    font-family: 'Playfair Display', serif;
    font-size: 36px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: #FFFFFF;
}

.footerjoinbtn {
    width: 180px;
    height: 64px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 100px 100px 100px 100px;
    font-size: 16px;
    color: #FFFFFF;
    border: none;
}

.footer-links {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 60px;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.footer-column-title {
    font-size: 16px;
    font-weight: 600;
    color: white;
    margin-bottom: 8px;
}

.footer-link {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    transition: color 0.3s;
}

.footer-link:hover {
    color: white;
}
</style>